module.exports = __webpack_public_path__ + "img/hh-star.91902e02.png";